exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".discoverSearchTagsChild[data-v-f9afbfe8]{width:100%!important}.disable-scroll[data-v-f9afbfe8]{overflow:hidden!important}#application-wrapper[data-v-f9afbfe8]{overflow:visible!important}.content-wrapper[data-v-f9afbfe8]{padding-top:80px;overflow-x:hidden;overflow-y:scroll;position:absolute;top:0;height:100%;width:100%}", ""]);

// exports
